import { MoveDirection } from '@generated/base-types';

export type DragAndDropEvent = {
  dragIndex: number;
  dropIndex: number;
};

export function getDirectionFromIndices(
  dragIndex: number,
  dropIndex: number
): MoveDirection {
  return dragIndex < dropIndex ? MoveDirection.Down : MoveDirection.Up;
}

export function getMoveQuantity(dragIndex: number, dropIndex: number): number {
  return Math.abs(dragIndex - dropIndex);
}
